import { MatDateFormats } from '@angular/material/core';
import { InjectionToken } from '@angular/core';

export const CCOMX_MAT_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'yyyy-MM-DD',
  },
  display: {
    dateInput: 'yyyy-MM-DD',
    monthYearLabel: 'MMMM yyyy',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};

export const GLOBAL_DATE_FORMATS = {
  DATE_ONLY: 'yyyy-MM-dd',
  DATE_WITH_TIME: 'yyyy-MM-dd HH:mm',
  DATE_WITH_TIME_WITH_SECONDS: 'yyyy-MM-dd HH:mm:ss',
  TIME_FORMAT: 'HH:mm',
  SHORT_TIME_FORMAT: 'H:mm',
  MONTH_YEAR: 'MMMM yyyy',
};

export const DEFAULT_DATE_FORMAT = GLOBAL_DATE_FORMATS.DATE_ONLY;
export const DEFAULT_DATE_TIME_FORMAT = GLOBAL_DATE_FORMATS.DATE_WITH_TIME;
export const DEFAULT_DATE_TIME_SECONDS_FORMAT = GLOBAL_DATE_FORMATS.DATE_WITH_TIME_WITH_SECONDS;
export const TIME_FORMAT = GLOBAL_DATE_FORMATS.TIME_FORMAT;
export const SHORT_TIME_FORMAT = GLOBAL_DATE_FORMATS.SHORT_TIME_FORMAT;

export const DATE_WITH_TIME_DISPLAY = {
  ...CCOMX_MAT_DATE_FORMATS,
  parse: {
    dateInput: 'yyyy-MM-DD HH:mm',
  },
  display: {
    ...CCOMX_MAT_DATE_FORMATS.display,
    dateInput: 'yyyy-MM-DD HH:mm',
  },
};

export const USE_DATE_TIME_FORMAT = new InjectionToken<boolean>('Use date-time format token');
